import { motion } from "framer-motion";
import { useState } from "react";


//Components
import ModalHeader from "../../others/ModalHeader";

import Hide from "./Hide";

function ModalHide(props) {
  const { referendum, setReferendum, titleSlug, setShowHideAction, setShowContent } = props;

  const OpenningAnimation = { scale: 1, translateY: "-50%" };
  const ClosingAnimation = { scale: 0, translateY: "-50%" };
  const [isOpen, setIsOpen] = useState(true);
  const [step, setStep] = useState("hide");


  const toggleOffInContainer = () => {
    setIsOpen(false);
    setTimeout(function () {
      if (step === "hidden") {
        setShowHideAction(false);
      } else {
        setShowHideAction(false);
      }
    }, 100);
  };

  const StepFunction = ({ step }) => {
    switch (step) {
      case "hidden":
        return (
          <motion.div>
            <motion.div
              initial={{ scale: 0.5, translateY: "-50%" }}
              animate={isOpen ? OpenningAnimation : ClosingAnimation}
              transition={{ type: "spring", duration: 0.3 }}
              onClick={(e) => {
                e.stopPropagation();
              }}
              className="op-box p-3 py-5 moderate-ref OPModalBox position-absolute mx-auto"
              style={{ minHeight: "auto" }}
            >
              <ModalHeader
                title="Moderate Referendum"
                toggleOffInContainer={toggleOffInContainer}
              />
              <div
                className={`row pt-3 px-3 align-items-center justify-content-center`}
              >
                <div className={`col-12 px-5 text-center`}>
                  <p className="op-text text-black">
                    This referendum has been moderated.
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        );
        // eslint-disable-next-line
        break;
      case "hide":
        return (
          <motion.div>
            <motion.div
              initial={{ scale: 0.5, translateY: "-50%" }}
              animate={isOpen ? OpenningAnimation : ClosingAnimation}
              transition={{ type: "spring", duration: 0.3 }}
              onClick={(e) => {
                e.stopPropagation();
              }}
              className="op-box p-3 py-5 moderate-ref OPModalBox position-absolute mx-auto"
            >
              <ModalHeader
                title="Moderate Referendum"
                toggleOffInContainer={toggleOffInContainer}
              />
              <div
                className={`row pt-3 px-3 align-items-center justify-content-center`}
              >
                <Hide
                  referendum={referendum}
                  setReferendum={setReferendum}
                  titleSlug={titleSlug}
                  setStep={setStep}
                  setShowContent={setShowContent}
                />
              </div>
            </motion.div>
          </motion.div>
        );
        // eslint-disable-next-line
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="OPModal position-absolute" onClick={toggleOffInContainer}>
        <StepFunction step={step} />
      </div>
    </>
  );
}
export default ModalHide;
